import { Chip } from '@/components/ui'
import type { SopStatus } from '../api/types'

const STATUS_LABEL: Record<SopStatus, string> = {
  draft: 'Draft',
  published: 'Published',
  archived: 'Archived',
}

const STATUS_VARIANT: Record<SopStatus, 'neutral' | 'success' | 'warning'> = {
  draft: 'warning',
  published: 'success',
  archived: 'neutral',
}

export function SopStatusChip({ status, size = 'xs' }: { status: SopStatus; size?: 'xs' | 'md' }) {
  return (
    <Chip size={size} variant={STATUS_VARIANT[status]} dot>
      {STATUS_LABEL[status]}
    </Chip>
  )
}
